import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import CkEditorComponent from "../../../CommonComponent/Editor/CkEditorComponent";

import { pushNotification } from "utils/notifications";

const EditMauThuChi = ({ show, onClose, data, onSave }) => {
  const editorRef = useRef(null);
  const [content, setContent] = useState("");
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const [saving, setSaving] = useState(false); // ✅ trạng thái loading khi lưu
  const [variables, setVariables] = useState([]);
  const variablesThuChi = [
    { label: "Ngày tạo", value: "{$NgayTaoPhieu}" },
    { label: "Người nộp", value: "{$NguoiNop}" },
    { label: "Người nhận", value: "{$NguoiNhan}" },
    { label: "Người lập", value: "{$NguoiLap}" },
    { label: "Tên khách hàng", value: "{$TenKhachHang}" },
    { label: "Ngày sinh", value: "{$NgaySinh}" },
    { label: "Số CMND", value: "{$SOCMT}" },
    { label: "Số CCCD", value: "{$SOCCCD}" },
    { label: "Nơi cấp", value: "{$NoiCap}" },
    { label: "Ngày cấp", value: "{$NgayCap}" },
    { label: "Hộ khẩu thường trú", value: "{$SHKTT}" },
    { label: "Điện thoại", value: "{$DienThoai}" },
    { label: "Mã hợp đồng", value: "{$MaHopDong}" },
    { label: "Mã Phiếu", value: "{$MaPhieu}" },
    { label: "Địa chỉ", value: "{$DiaChi}" },
    { label: "Ghi chú", value: "{$GhiChu}" },
    { label: "Nội dung", value: "{$NoiDung}" },
    { label: "Tổng số tiền thực thu", value: "{$SoTienThucThu}" },
    { label: "Số tiền thực thu bằng chữ", value: "{$SoTienThucThuBangChu}" },
    { label: "Số tiền chi", value: "{$SoTienChi}" },
    { label: "Số tiền thực chi bằng chữ", value: "{$SoTienThucChiBangChu}" },
    { label: "Số tiền cần thanh lý", value: "{$SoTienCanThanhLy}" },
    { label: "Số tiền lệch thừa", value: "{$SoTienLech}" },
    { label: "Tiền lãi", value: "{$TienLai}" },
    { label: "Phí hàng kỳ", value: "{$PhiHangKy}" },
    { label: "Số tiền phí hàng kỳ", value: "{$PhiHangKyPhanBo}" },
    { label: "Tiền gốc", value: "{$GocPhanBo}" },
    { label: "Lãi phân bổ", value: "{$LaiPhanBo}" },
    { label: "Phí kho", value: "{$PhiKho}" },
    { label: "Phí khác", value: "{$PhiKhac}" },
    { label: "Phạt chậm đóng lãi", value: "{$PhatChamDongLai}" },
    { label: "Phạt tất toán sớm", value: "{$PhatTatToanSom}" },
    { label: "Ngày thu/chi", value: "{$NgayThuChi}" },
    { label: "Ngày vay", value: "{$NgayVay}" },
    { label: "Ngày kết thúc", value: "{$NgayKetThuc}" },
    { label: "Tiền vay", value: "{$TienVay}" },
    { label: "Số tiền bằng chữ", value: "{$TienVayBangChu}" },
    { label: "Tiền vay cũ", value: "{$TienVayCu}" },
    { label: "Tiền vay cũ bằng chữ", value: "{$TienVayCuBangChu}" },
    { label: "Số lần trả", value: "{$SoLanTra}" },
    { label: "Lãi đến ngày hôm nay", value: "{$LaiDenNgayHomNay}" },
    { label: "Lãi xuất", value: "{$LaiXuat}" },
    { label: "Tài sản thế chấp", value: "{$TaiSanTheChap}" },
    { label: "Giờ tạo", value: "{$GioTao}" },
    { label: "Lần đóng", value: "{$LanDong}" },
    { label: "Tên tài sản 1", value: "{$tenTaiSan1}" },
    { label: "Thuộc tính tài sản 1", value: "{$ThuocTinhTaiSan1}" },
    { label: "Mã vạch tài sản 1", value: "{$CodeTaiSan1}" },
    { label: "Mã vạch tài sản 2", value: "{$CodeTaiSan2}" },
    { label: "Mã vạch tài sản 3", value: "{$CodeTaiSan3}" },
    { label: "Tên tài sản 2", value: "{$TenTaiSan2}" },
    { label: "Từ ngày đóng", value: "{$tuNgayDongLai}" },
    { label: "Đến ngày đóng", value: "{$DenNgayDongLai}" },
    { label: "Gia hạn từ ngày", value: "{$CodeTaiSan2}" },
    { label: "Gia hạn đến ngày", value: "{$GiaHanDenNgay}" },
    { label: "Ngày đóng lãi tiếp theo", value: "{$TimeTiepTheo}" },
    { label: "Kỳ 1 từ ngày", value: "{$TimeKy11}" },
    { label: "Kỳ 1 đến ngày", value: "{$Timeky12}" },
    { label: "Kỳ 2 từ ngày", value: "{$TimeKy21}" },
    { label: "Kỳ 2 đến ngày", value: "{$TimeKy22}" },
    { label: "Kỳ 3 từ ngày", value: "{$TimeKy31}" },
    { label: "Kỳ 3 đến ngày", value: "{$Timeky32}" },
    { label: "Kỳ 4 từ ngày", value: "{$TimeKy41}" },
    { label: "Kỳ 4 đến ngày", value: "{$TimeKy42}" },
    { label: "Kỳ 5 từ ngày", value: "{$TimeKy51}" },
    { label: "Kỳ 5 đến ngày", value: "{$TimeKy52}" },
    { label: "Tiền lãi còn lại phải đóng", value: "{$TienLaiConLaiPhaiDong}" },
    { label: "Tổng số ngày vay thực tế", value: "{$TongSoNgayVayThucTe}" },
    { label: "Công thức tính lãi còn lại", value: "{$CongThucTinhLaiConLai}" },
  ];

  const variablesBH = [
    { label: "Ngày tạo", value: "{$NgayTaoPhieu}" },
    { label: "Mã Phiếu", value: "{$MaPhieu}" },
    { label: "Tên khách hàng", value: "{$TenKhachHang}" },
    { label: "Điện thoại", value: "{$DienThoai}" },
    { label: "Địa chỉ", value: "{$DiaChi}" },
    { label: "Danh sách tài sản", value: "{$DanhSachTaiSan}" },
    { label: "Tổng tiền", value: "{$TongTien}" },
    { label: "Tổng tiền thanh toán", value: "{$TongTienThanhToan}" },
  ];

  useEffect(() => {
    if (data) {
      //console.log(data);
      setContent(data.ContractContent || "");
      setName(data.ContractName || "");
      setId(data.ContractId || "");
      if (editorRef.current) {
        editorRef.current.setData(data.ContractContent || "");
      }
      var type = data.Keyword ?? "";
      if (
        type === "NHAPHANG" ||
        type === "BANHANG" ||
        type === "CHENHLECHBANHANG"
      ) {
        setVariables(variablesBH);
      } else {
        setVariables(variablesThuChi);
      }
    }
  }, [data]);

  useEffect(() => {
    //console.log("content",content);
  }, [content]);

  const handleKeyDown = (event) => {
    if (event.key === "Escape") onClose();
  };

  useEffect(() => {
    if (show) document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [show]);

  const handleInsertVariable = (variable) => {
    if (editorRef.current) {
      editorRef.current.insertText(variable);
    }
  };

  const handleSave = async () => {
    const editorData = editorRef.current?.getData() || content;
    const updated = {
      ...data,
      ContractId: id,
      ContractName: name,
      ContractContent: editorData,
    };

    try {
      setSaving(true);
      await onSave(updated);
    } catch (err) {
      console.error("Lỗi khi lưu:", err);
      pushNotification(
        "Có lỗi xảy ra khi cập nhật. Vui lòng thử lại.",
        "error",
        "TOP_CENTER",
        1000,
      );
    } finally {
      setSaving(false);
    }
  };

  if (!show) return null;
  return (
    <>
      <Modal
        show={show}
        dialogClassName="modal-90w"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        {/* Header */}
        <Modal.Header>
          <h4 className="modal-title color7-bold">
            <span className="btn-icon-right">
              <img
                src="/app-assets/images/icon-hop-dong-cho-duyet.png"
                alt="icon"
              />
            </span>
            Sửa mẫu thu chi
          </h4>
          <button type="button" className="close-popup-new" onClick={onClose}>
            <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
          </button>
        </Modal.Header>

        {/* Body */}
        <Modal.Body>
          <div className="row">
            <div
              className="col-md-3"
              style={{
                borderRight: "1px solid #ddd",
                maxHeight: "500px",
                overflowY: "auto",
              }}
            >
              <h6 className="text-white bg-teal p-2">Ghi chú</h6>
              <ul className="list-unstyled p-2">
                {variables.map((v, idx) => (
                  <li
                    key={idx}
                    style={{ cursor: "pointer", marginBottom: "6px" }}
                    onClick={() => handleInsertVariable(v.value)}
                  >
                    {v.label} <span className="text-muted">({v.value})</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* CKEditor */}
            <div className="col-md-9">
              <div className="form-group">
                <label
                  className="label-control color7-bold"
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginBottom: 8,
                  }}
                >
                  Tên mẫu thu chi
                </label>
                <input
                  type="text"
                  className="form-control input-sm"
                  value={name}
                  readOnly
                  style={{ fontSize: "16px", height: "40px", marginBottom: 16 }}
                />
              </div>
              <CkEditorComponent
                key={id}
                ref={editorRef}
                value={content}
                onChange={setContent}
                name_editor="mau-thu-chi-editor"
              />
            </div>
          </div>
        </Modal.Body>

        {/* Footer */}
        <Modal.Footer>
          <button
            className="btn btn-new-main btn-closenew"
            onClick={onClose}
            disabled={saving}
          >
            <span>
              <i className="mdi mdi-close"></i>
            </span>
            &nbsp; Đóng
          </button>
          <button
            className="btn btn-new-main button-popup-submit"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? (
              <>
                <span className="spinner-border spinner-border-sm"></span>&nbsp;
                Đang lưu...
              </>
            ) : (
              <>
                <i className="mdi mdi-content-save"></i>&nbsp; Cập nhật
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditMauThuChi;
